import React, {Component} from 'react';

import {Col} from 'antd';

export default class InfoGroup extends Component {
	render() {
		return (<Col span={6}>
			<h3>{this.props.label}</h3>
			<p>{this.props.data}</p>
		</Col>);
	}
}
